import fetch from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { convertFiltersToV5Format } from '../../utils/filterFormatConversionToV5';
import store from '../store';
import { enqueueSnackbar } from './snackbar';

export const listFieldPicturesDrill = (payload) => (dispatch) => {
  const { fieldPicturesDrill } = store.getState();
  dispatch({
    type: REDUX_ACTIONS.FIELD_PICTURES_DRILL_LIST_LOADING,
  });
  const body = {
    query: {
      startDate: payload?.startDate || fieldPicturesDrill?.startDate,
      endDate: payload?.endDate || fieldPicturesDrill?.endDate,
      searchValue: payload?.searchValue || fieldPicturesDrill?.searchValue,
      limit: 100,
      page: payload?.page || 1,
      filters: convertFiltersToV5Format(fieldPicturesDrill?.filters?.items) || [],
      linkOperator: fieldPicturesDrill?.filters?.logicOperator || 'and',
      sort: fieldPicturesDrill?.sort || null
    }
  };
  return fetch
    .post('pictures/drill', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.FIELD_PICTURES_DRILL_LIST_SUCCESS,
        payload: {
          data: data.data,
          paginatedElements: data.data.count,
          totalCount: data.count
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.FIELD_PICTURES_DRILL_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};
